import attackers from "./test/attackers"
import complexProfiles from "./test/complexProfiles"
import defenders from "./test/defenders"
import weaponAbilities01 from "./test/weaponAbilities01"
import weaponAbilities02 from "./test/weaponAbilities02"
import weaponAbilities03 from "./test/weaponAbilities03"

export default [
  ...attackers,
  ...complexProfiles,
  ...defenders,
  ...weaponAbilities01,
  ...weaponAbilities02,
  ...weaponAbilities03,
]
